
import OneBit from './saint11/1-bit.gif';
import FourLegWalk from './saint11/4LegsWalk.gif';
import AttackSheet from './saint11/AttackSheet.gif';
import Blood from './saint11/Blood.gif';
import Breaking from './saint11/Breaking.gif';
import Bullets from './saint11/Bullets.gif';
import Idle from './saint11/characterIdle.gif';
import City from './saint11/City.gif';
import Clouds from './saint11/Clouds.gif';
import Cuteness from './saint11/Cuteness.gif';
import DarkMagic from './saint11/DarkMagic.gif';
import Darkness from './saint11/Darkness.gif';
import Death from './saint11/Death.gif';
import Defend from './saint11/Defend.gif';
import Easings from './saint11/Easings.gif';
import Electric from './saint11/Electric.gif';
import Explosion from './saint11/Explosion.gif';
import Fabric from './saint11/Fabric.gif';
import Fire from './saint11/Fire.gif';
import Firearm from './saint11/FirearmDesign.gif';
import Fundamentals from './saint11/Fundamentals.gif';
import Fundamentals2 from './saint11/Fundamentals2.gif';
import Gems from './saint11/gems.gif';
import Glitch from './saint11/Glitch.gif';
import Goo from './saint11/Goo.gif';
import Hazards from './saint11/Hazards.gif';
import Holograms from './saint11/Holograms-Ghosts.gif';
import Ice from './saint11/Ice.gif';
import Illumination from './saint11/IlluminationTechniques.gif';
import Impact from './saint11/Impact-export.gif';
import Indoors from './saint11/indoors.gif';
import Isometric from './saint11/Isometric.gif';
import Jump from './saint11/Jump.gif';
import LightMagic from './saint11/LightMagic.gif';
import Loop from './saint11/loop.gif';
import Metal from './saint11/Metal.gif';
import Modular from './saint11/Modular.gif';
import MotionBlur from './saint11/MotionBlur.gif';
import Outlines from './saint11/Outlines.gif';
import Parallax from './saint11/Parallax.gif';
import Perspective from './saint11/Perspective.gif';
import Planning from './saint11/Planning.gif';
import Portrait from './saint11/Portrait.gif';
import Rock from './saint11/Rock.gif';
import RocketTrail from './saint11/RocketTrail.gif';
import Ruins from './saint11/Ruins.gif';
import RunCycle from './saint11/RunCycleSimple.gif';
import Sand from './saint11/Sand.gif';
import Shading from './saint11/Shading.gif';
import Shine from './saint11/Shine.gif';
import Silhouette from './saint11/Silhouette.gif';
import Skull from './saint11/skull.gif';
import SlideRoll from './saint11/Slide-Roll.gif';
import Smoke from './saint11/SmokeSheet.gif';
import Spaceships from './saint11/Spaceships.gif';
import Squash from './saint11/Squash.gif';
import Stars from './saint11/Stars.gif';
import Subpixel from './saint11/Subpixel.gif';
import Swords from './saint11/Swords.gif';
import Tech from './saint11/Tech.gif';
import Tiles from './saint11/Tiles.gif';
import TopDownHouses from './saint11/Top-Down-Houses.gif';
import TopDownAttack from './saint11/TopDownAttack.gif';
import TopDownRun from './saint11/TopDownRun.gif';
import TopDownTricks from './saint11/TopDownTricks.gif';
import TopDownWalk from './saint11/TopDownWalkCycle.gif';
import NineSlice from './saint11/UI-9-Slice.gif';
import Vegetation from './saint11/Vegetation.gif';
import Vegetation2 from './saint11/Vegetation2.gif';
import Vegetation3 from './saint11/Vegetation3.gif';
import Walk from './saint11/Walk.gif';
import WallSlide from './saint11/WallSlide.gif';
import Water from './saint11/Water.gif';
import Wind from './saint11/Wind.gif';
import Wings from './saint11/Wings.gif';
import Wood from './saint11/Wood.gif';


export const SAINT_11 = 'SAINT_11';

const articleData = [];

function addItem( image, title, creator, key ) {
  articleData.push( {
    image,
    title,
    creator,
    key,
  } );
}

addItem( OneBit, '1-bit', SAINT_11, 'onebit' );
addItem( FourLegWalk, 'Quadruped Walk', SAINT_11, 'quadwalk' );
addItem( AttackSheet, 'Attack Animation', SAINT_11, 'attackanim' );
addItem( Blood, 'Blood and Guts', SAINT_11, 'bloodguts' );
addItem( Breaking, 'Breaking Objects', SAINT_11, 'breakingobjects' );
addItem( Bullets, 'Bullets', SAINT_11, 'bullets' );
addItem( Idle, 'Character Idle', SAINT_11, 'charidle' );
addItem( City, 'City Backgrounds', SAINT_11, 'cityback' );
addItem( Clouds, 'Clouds', SAINT_11, 'clouds' );
addItem( Cuteness, 'Cuteness', SAINT_11, 'cuteness' );
addItem( DarkMagic, 'Dark Magic Effects', SAINT_11, 'darkmagic' );
addItem( Darkness, 'Darkness', SAINT_11, 'darkness' );
addItem( Death, 'Death / Take Hit', SAINT_11, 'death' );
addItem( Defend, 'Defend', SAINT_11, 'defend' );
addItem( Easings, 'Easings', SAINT_11, 'easings' );
addItem( Electric, 'Electricity', SAINT_11, 'electricity' );
addItem( Explosion, 'Explosions', SAINT_11, 'explosions' );
addItem( Fabric, 'Fabric / Flags', SAINT_11, 'fabric' );
addItem( Fire, 'Fire', SAINT_11, 'fire' );
addItem( Firearm, 'Firearm Design', SAINT_11, 'firearm' );
addItem( Fundamentals, 'Pixel Art Fundamentals 1', SAINT_11, 'fundamentals' );
addItem( Fundamentals2, 'Pixel Art Fundamentals 2', SAINT_11, 'fundamentals2' );
addItem( Gems, 'Gems', SAINT_11, 'gems' );
addItem( Glitch, 'Glitch Effects', SAINT_11, 'glitch' );
addItem( Goo, 'Fluids / Slime', SAINT_11, 'goo' );
addItem( Hazards, 'Environmental Hazards', SAINT_11, 'hazards' );
addItem( Holograms, 'Holograms / Ghosts', SAINT_11, 'holograms' );
addItem( Ice, 'Ice', SAINT_11, 'ice' );
addItem( Illumination, 'Illumination Techniques', SAINT_11, 'illumination' );
addItem( Impact, 'Impact', SAINT_11, 'impact' );
addItem( Indoors, 'Modern / Indoors', SAINT_11, 'indoors' );
addItem( Isometric, 'Isometric', SAINT_11, 'isometric' );
addItem( Jump, 'Jump', SAINT_11, 'jump' );
addItem( LightMagic, 'Light Magic Effects', SAINT_11, 'lightmagic' );
addItem( Loop, 'Seamless Looping', SAINT_11, 'loop' );
addItem( Metal, 'Metals', SAINT_11, 'metal' );
addItem( Modular, 'Modular Animation', SAINT_11, 'modular' );
addItem( MotionBlur, 'Motion Blur', SAINT_11, 'motionblur' );
addItem( Outlines, 'Outlines', SAINT_11, 'outlines' );
addItem( Parallax, 'Parallax and Depth', SAINT_11, 'parallax' );
addItem( Perspective, 'Basic Perspective', SAINT_11, 'perspective' );
addItem( Planning, 'Animation Planning', SAINT_11, 'animplanning' );
addItem( Portrait, 'Portraits', SAINT_11, 'portrait' );
addItem( Rock, 'Rock Formations', SAINT_11, 'rocks' );
addItem( RocketTrail, 'Spaceship Propulsion', SAINT_11, 'rockettrail' );
addItem( Ruins, 'Ruins', SAINT_11, 'ruins' );
addItem( RunCycle, 'Run Cycle', SAINT_11, 'runcycle' );
addItem( Sand, 'Sand', SAINT_11, 'sand' );
addItem( Shading, 'Shading', SAINT_11, 'shading' );
addItem( Shine, 'Shine', SAINT_11, 'shine' );
addItem( Silhouette, 'Silhouette', SAINT_11, 'silhouette' );
addItem( Skull, 'Skull and Bones', SAINT_11, 'skull' );
addItem( SlideRoll, 'Slide / Roll / Dash', SAINT_11, 'slideroll' );
addItem( Smoke, 'Smoke Effect', SAINT_11, 'smoke' );
addItem( Spaceships, 'Spaceships', SAINT_11, 'spaceships' );
addItem( Squash, 'Squash and Stretch', SAINT_11, 'squash' );
addItem( Stars, 'Space / Stars', SAINT_11, 'stars' );
addItem( Subpixel, 'Subpixel Movement', SAINT_11, 'subpixel' );
addItem( Swords, 'Swords', SAINT_11, 'swords' );
addItem( Tech, 'Machines and Weird Tech', SAINT_11, 'tech' );
addItem( Tiles, 'Tiles', SAINT_11, 'tiles' );
addItem( TopDownHouses, 'Top Down Houses', SAINT_11, 'topdownhouses' );
addItem( TopDownAttack, 'Top Down Attack', SAINT_11, 'topdownattack' );
addItem( TopDownRun, 'Top Down Run Cycle', SAINT_11, 'topdownrun' );
addItem( TopDownTricks, 'Top Down Tricks', SAINT_11, 'topdowntricks' );
addItem( TopDownWalk, 'Top Down Walk Cycle', SAINT_11, 'topdownwalk' );
addItem( NineSlice, 'User Interface 9 Slice', SAINT_11, 'nineslice' );
addItem( Vegetation, 'Vegetation Part 1', SAINT_11, 'vegetation1' );
addItem( Vegetation2, 'Vegetation Part 2', SAINT_11, 'vegetation2' );
addItem( Vegetation3, 'Vegetation Part 3', SAINT_11, 'vegetation3' );
addItem( Walk, 'Walk Cycle', SAINT_11, 'walk' );
addItem( WallSlide, 'Wall Slide / Kick', SAINT_11, 'wallslide' );
addItem( Water, 'Water Animation', SAINT_11, 'water' );
addItem( Wind, 'Wind', SAINT_11, 'wind' );
addItem( Wings, 'Wings / Flying', SAINT_11, 'wings' );
addItem( Wood, 'Wood', SAINT_11, 'wood' );


export default articleData;
